import { render, staticRenderFns } from "./orgMap.vue?vue&type=template&id=545d13ca&"
import script from "./orgMap.vue?vue&type=script&lang=js&"
export * from "./orgMap.vue?vue&type=script&lang=js&"
import style0 from "./orgMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports